<script type="text/ecmascript-6">
    import {mapGetters} from "vuex";

    export default {
        /**
         * Computed these properties.
         */
        computed: {
            ...mapGetters({
                isPreview: 'getIsPreview',
            })
        },
    }
</script>

<template>
    <footer class="sticky-footer bg-white" v-show="!isPreview">
        <div class="container my-auto">
            <div class="copyright text-center my-auto">
                <span>Copyright &copy; {{ moment().format("Y")}}</span>
            </div>
        </div>
    </footer>
</template>
